import React from 'react';
import SCloud from '../../components/sCloud/Cloud.jsx';

const sCloud = () => {
  return (
    <>
      {/* Footer Section  */}
      <section>
        <SCloud />
      </section>
    </>
  );
};

export default sCloud;
